import { buildErrorThrower } from '@clerk/shared/error';

export const errorThrower = buildErrorThrower({ packageName: '@clerk/nextjs' });
